module.exports = __webpack_public_path__ + "img/tab-13.4da2e0b6.png";